import SdlTabs from './VueTabs';
import SdlTab from './VTab';

const SdlTabsPlugin = {
  install(Vue) {
    Vue.component('sdl-tabs', SdlTabs);
    Vue.component('sdl-tab', SdlTab);
  },
};

export default SdlTabsPlugin;
export { SdlTabs, SdlTab };



// WEBPACK FOOTER //
// ./src/components/common/control/tabs/index.js